import axios from "axios"
import { logOut } from "../actions/AuthAction";
import store from '../store/ReduxStore';

const API = axios.create({baseURL: process.env.REACT_APP_API_BASE_URL, withCredentials: true});

API.interceptors.response.use(
    response => response, 
    error => {
        if (error.response && error.response.status === 401) {
            console.log("Token expired, logging out user...");

            // Dispatch logout action
            store.dispatch(logOut());
        }
        return Promise.reject(error);
    }
);
// Why can't I add more lines to each of the below arrow functions without
// it affecting the async nature of the function when called in authaction?
export const saveForm = (formData, formName, formId, userId, sessionId) => API.post(`/form/${userId}/save`, {
  formData,
  formName,
  formId,
  sessionId
})

export const getSheetInformation = (sheetId) => API.post(`/form/sheet/${sheetId}`)

export const deleteForm = (userId, formId) => API.post(`/form/remove/${userId}`, {
  formId
})

export const getDatumItemList = (userId, productId, refId, style) => API.post('/form/getDatumItems', {
  userId: userId,
  productId: productId,
  secondId: refId,
  type: style
})

export const getDatumItemById = (id) => API.post('/form/getDatumItemById', {
  id: id
})

export const getDatumRelation = (productId, secondId, datumId) => API.post('/form/getDatumRelation', {
  productId,
  secondId,
  datumId
})